<template>
  <ul v-if="checkRouterAccess()" :class="itemClass" class="item-collapse">
    <li
      v-if="hasChildren"
      class="dash-nav-row"
      v-b-toggle="`collapse-${id}`"
      @click="customAction"
    >
      <div class="dash-nav-item is-parent">
        <b-icon class="dash-nav-icon" :icon="icon"></b-icon>
        <span class="dash-nav-label">{{ name }}</span>
        <b-icon icon="chevron-down" class="dash-nav-chevron"></b-icon>
      </div>
    </li>
    <li v-else class="dash-nav-row" @click="customAction">
      <router-link
        class="dash-nav-item"
        :class="{ 'is-current': isCurrentRoute }"
        :to="route"
        exact
      >
        <b-icon class="dash-nav-icon" :icon="icon"></b-icon>
        <span class="dash-nav-label">{{ name }}</span>
      </router-link>
    </li>

    <SubItem
      v-if="hasChildren"
      :id="id"
      :step="1"
      :children="children"
    />
  </ul>
</template>

<script>
import SubItem from './subItem'
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";
import {mapGetters} from "vuex";

export default {
  name: "item",
  components: {SubItem},
  props: ['name', 'icon', 'route', 'children', 'id', 'action', 'access', 'itemClass', 'module'],
  computed: {
    ...mapGetters({
      isStore: "User/isUserStore"
    }),
    hasChildren() {
      return Array.isArray(this.children) && this.children.length > 0
    },
    isCurrentRoute() {
      const name = this.route && this.route.name
      return Boolean(name) && this.$route.name === name
    },
  },
  methods: {
    customAction() {
      if (this.action !== undefined) {
        this.action()
      }
    },
    checkRouterAccess() {
      let userProfile = this.$store.getters['User/getProfile'];

      if (this.module === 'odoo_helpdesk') {
        if (process.env.VUE_APP_ODOO_HELPDESK_ENABLED === 'false') {
          return false
        }
        if (this.$store.getters['HelpdeskTicket/isEnabled'] === false) {
          return false
        }
      }

      if (findAttributeOnSiteInfo('store_access_to_content_management')[0] == 1 && this.name == 'مدیریت محتوا' && this.isStore) {
        return false
      }

      if (!this.access || this.access.length === 0) {
        return true
      }
      let userAccessNumber = `${userProfile.role}-${userProfile.type}`
      return this.access.indexOf(userAccessNumber) > -1
    }
  }
}
</script>

<style scoped>
.item-collapse {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dash-nav-row {
  list-style: none;
  cursor: pointer;
}

.dash-nav-item {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  margin: 2px 0;
  padding: 8px 10px;
  border-radius: 12px;
  color: rgba(255, 255, 255, 0.88) !important;
  text-decoration: none !important;
  font-size: 13px;
  line-height: 1.4;
  transition: background 0.2s ease, color 0.2s ease;
}

.dash-nav-icon {
  flex-shrink: 0;
  font-size: 15px;
}

.dash-nav-label {
  flex: 1;
  min-width: 0;
  text-align: right;
}

.dash-nav-chevron {
  flex-shrink: 0;
  font-size: 12px;
  opacity: 0.7;
  transition: transform 0.2s ease;
}

.dash-nav-item:hover,
.dash-nav-item:focus {
  background: rgba(255, 255, 255, 0.08);
  color: #fff !important;
  outline: none;
}

.dash-nav-item.is-current {
  background: #eb3d60;
  color: #fff !important;
  box-shadow: 0 8px 16px rgba(235, 61, 96, 0.28);
}

.not-collapsed .dash-nav-chevron {
  transform: rotate(180deg);
}
</style>